import { createAsyncThunk } from '@reduxjs/toolkit';

/**
 * Generates (or returns the previously generated) retention discount
 * promotion code for the current team. The server enforces the
 * once-per-team limit — if the discount has already been redeemed the
 * call rejects with HTTP 403 and the offer should be suppressed in UI.
 */
const generateRetentionCoupon = createAsyncThunk(
  'billing/generateRetentionCoupon',
  async (
    _,
    {
      rejectWithValue, extra: {
        sdk, Logger,
      },
    },
  ) => {
    try {
      const { data } = await sdk.billing.generateRetentionCoupon();
      Logger.log('User', 'CancellationFlowRetentionCouponGenerated');
      return data;
    } catch (error) {
      Logger.error(
        new Error('Retention coupon generation failed'),
        { error },
        [
          'RetentionCouponGenerationFailed',
          {
            errorMessage: (error && error.message) || 'NoMessage',
            httpStatus: (error && error.response && String(error.response.status)) || 'unknown',
          },
        ],
      );
      return rejectWithValue(error);
    }
  },
);

export default generateRetentionCoupon;
